<template>
    <el-form-item prop="table_copy_y" label-width="0px" v-if="visible">
        <el-row :gutter="20">
            <el-col :md="10" :lg="8">
                <el-form-item
                    class="item-fome-base item-left table-copy-y-field"
                    label="Y軸コピー元ID"
                    prop="copy_y_key_ref">
                    <el-select
                        class="w--10 bg-gray-item table-copy-y-select"
                        :value="value"
                        @input="$emit('input', $event)"
                        placeholder="選択してください"
                        clearable>
                        <el-option label="なし" :value="null"></el-option>
                        <el-option
                            v-for="(parentY, pIndex) in parentYOptions"
                            :key="'copy-y-' + pIndex"
                            :label="parentY.label_name"
                            :value="parentY.field_key">
                        </el-option>
                    </el-select>
                    <div class="text-initial">
                        <label v-if="copyError" class="text-danger text-left">
                            {{ copyError.msg }}
                        </label>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form-item>
</template>

<script>
import {
    canShowTableCopyYSelect,
    getParentTableYItemsForCopy,
} from '@/core/utils/formTableCopy';

export default {
    props: {
        value: {},
        yItem: {
            type: Object,
            required: true,
        },
        formBase: {
            type: Object,
            default: null,
        },
        field: {
            type: Object,
            default: null,
        },
        copyError: {
            type: Object,
            default: null,
        },
    },
    computed: {
        copyContext() {
            return {
                field: this.field,
                formBase: this.formBase,
            };
        },
        visible() {
            return canShowTableCopyYSelect(this.yItem, this.copyContext);
        },
        parentYOptions() {
            return getParentTableYItemsForCopy(this.yItem, this.copyContext);
        },
    },
};
</script>

<style lang="scss">
.table-copy-y-field {
    .el-form-item__content {
        min-width: 280px;
    }
}

.table-copy-y-select {
    width: 100%;
    min-width: 280px;

    .el-input {
        min-width: 280px;
    }

    .el-input__inner {
        min-width: 280px;
    }
}
</style>
